export default __webpack_public_path__ + "static/media/06__o_preview_2.72ac50f0.jpg";